/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AlbumManagementAddImageUploadResponse } from "./AlbumManagementAddImageUploadResponse";

export type AlbumManagementAddImageUploadResponseApiRespoonse = {
  data?: AlbumManagementAddImageUploadResponse;
  status?: AlbumManagementAddImageUploadResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AlbumManagementAddImageUploadResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
